import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden border-t" style={{ background: "#0F0E0C", borderColor: "rgba(244,237,217,0.08)" }} data-testid="site-footer">
      {/* Richmond skyline bg */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1628116904332-7c0ec0cbc623?fm=jpg&q=85&w=2400&auto=format&fit=crop&ixlib=rb-4.1.0')",
          backgroundSize: "cover",
          backgroundPosition: "center 70%",
          opacity: 0.18,
        }}
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, #0F0E0C 0%, rgba(15,14,12,0.75) 50%, #0F0E0C 100%)" }} />

      <div className="glow-green -bottom-40 -left-40 opacity-50" />
      <div className="glow-blue -bottom-40 -right-40 opacity-50" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid lg:grid-cols-3 gap-12 mb-16">
          <div className="lg:col-span-2">
            <h3 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight">
              One City.<br />
              One <span className="text-forest-glow">Generation</span>.<br />
              One <span className="text-deepblue-glow">Mission</span>.
            </h3>
            <Link to="/gatherings#rsvp" className="btn-primary mt-8" data-testid="footer-cta-button">
              Join The Next Gathering <ArrowUpRight size={16} />
            </Link>
          </div>
          <div className="flex flex-col justify-end gap-5">
            <a
              href="https://instagram.com/rvastudents"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-3 font-heading text-xl hover:text-forest-glow transition-colors"
              data-testid="footer-instagram-link"
            >
              <Instagram size={22} /> @rvastudents
              <ArrowUpRight size={18} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </a>
            <a
              href="mailto:studentsofrva@gmail.com"
              className="group flex items-center gap-3 font-heading text-base hover:text-deepblue-glow transition-colors break-all"
              data-testid="footer-email-link"
            >
              <Mail size={20} /> studentsofrva@gmail.com
            </a>
            <Link
              to="/contact"
              className="group flex items-center gap-3 font-heading text-base hover:text-deepblue-glow transition-colors"
              data-testid="footer-contact-link"
            >
              Contact Us <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
          </div>
        </div>

        <div className="hr-line mb-6" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-white/50 font-body">
            © {new Date().getFullYear()} RVA Students. Made with love in Richmond.
          </p>
          <p className="font-heading text-[0.68rem] uppercase tracking-[0.24em] text-white/50">
            For His name. For this city. For this generation.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
